/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import DashboardContainer from './dashboard/DashboardContainer';
import EwalletServicesReport from './report/containers/EwalletServicesReport';

function EWalletServiceContainer({ match }) {

  const permissions = getJson('permissions');

  return (
    <>
      <div className="module-inner">
        <div className="module-inner-title">E-Wallet Services</div>
        <div className="generic-module-nav mb-3">
          <NavLink
            exact
            className="nav-link"
            activeClassName="active"
            to="/e-wallet"
          >
            Dashboard
          </NavLink>
          {Acl(permissions, ['VIEW E-WALLET REPORT']) && (
            <NavLink
              exact
              className="nav-link"
              activeClassName="active"
              to="/e-wallet/report"
            >
              Report
            </NavLink>
          )}
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            component={DashboardContainer}
          />
          <Route
            path={`${match.path}/report`}
            component={EwalletServicesReport}
          />
        </Switch>
      </div>
    </>
  );
}

EWalletServiceContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(EWalletServiceContainer);
